import HusklyLogo from "./HusklyLogo";

export default function Footer() {
  return (
    <footer className="border-t border-navy-700/60 py-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <HusklyLogo className="h-9 w-12" />
            <div className="flex flex-col leading-none gap-0.5">
              <span className="text-sm font-bold text-gradient">
                Huskly Finance
              </span>
              <span className="text-[10px] text-slate-600 tracking-widest uppercase">
                Aegis Vol
              </span>
            </div>
          </div>

          <p className="text-xs text-slate-600 text-center max-w-sm">
            News-Aware Volatility Intelligence for Equity Options.{" "}
            <span className="text-slate-700">
              Not investment advice. All trade intents require human review
              before execution.
            </span>
          </p>

          <div className="flex items-center gap-4">
            <a
              href="https://huskly.finance"
              className="text-xs text-slate-600 hover:text-slate-400 transition-colors"
            >
              huskly.finance
            </a>
            <span className="text-slate-800">·</span>
            <span className="text-xs text-slate-700">
              © 2026 Huskly Finance
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
